import axios from '@axios';
import qs from 'qs';
import _ from 'lodash';

const initialQuery = () => {
    return {
        sort: ['id:asc'],
        filters: {
            occupationPercentage: {
                $between: [0, 100],
            },
            location: {
                parent: {
                    parent: {
                        parent: {
                            id: {
                                $containsi: '',
                            },
                        },
                        id: {
                            $containsi: '',
                        },
                    },
                    id: {
                        $containsi: '',
                    },
                },
                id: {
                    $containsi: '',
                },
            },
            $or: [
                {
                    name: {
                        $containsi: '',
                    },
                },
                {
                    email: {
                        $containsi: '',
                    },
                },

                {
                    location: {
                        name: {
                            $containsi: '',
                        },
                    },
                },
                {
                    location: {
                        parent: {
                            name: {
                                $containsi: '',
                            },
                        },
                    },
                },
                {
                    location: {
                        parent: {
                            parent: {
                                name: {
                                    $containsi: '',
                                },
                            },
                        },
                    },
                },
                {
                    location: {
                        parent: {
                            parent: {
                                parent: {
                                    name: {
                                        $containsi: '',
                                    },
                                },
                            },
                        },
                    },
                },
                {
                    managers: {
                        name: {
                            $containsi: '',
                        },
                    },
                },
            ],
        },
        populate: ['pictures', 'location.parent.parent.parent', 'managers'],
        pagination: {
            page: 1,
            pageSize: 5,
        },
    };
};

export default {
    namespaced: true,
    state: {
        parks: [],
        query: initialQuery(),
        isDeletePark: false,
    },
    getters: {
        getParkList(state) {
            return state.parks;
        },
        getParkQuery(state) {
            return state.query;
        },
        getPark(state) {
            return state.park;
        },
        getIsDeletePark(state) {
            return state.isDeletePark;
        },
    },
    mutations: {
        setParkList(state, parks) {
            state.parks = parks;
        },
        setParkQuery(state, query) {
            state.query = query;
        },
        resetParkQuery(state) {
            state.query = initialQuery();
        },
        setPark(state, parkData) {
            state.parkData = parkData;
        },
        setParkSearch(state, search) {
            state.query.filters.$or[0].name.$containsi = search;
            state.query.filters.$or[1].email.$containsi = search;
            state.query.filters.$or[2].location.name.$containsi = search;
            state.query.filters.$or[3].location.parent.name.$containsi = search;
            state.query.filters.$or[4].location.parent.parent.name.$containsi = search;
            state.query.filters.$or[5].location.parent.parent.parent.name.$containsi = search;
            state.query.filters.$or[6].managers.name.$containsi = search;
        },
        setIsDeletePark(state, bol) {
            state.isDeletePark = bol;
        },
    },
    actions: {
        fetchParkList(ctx) {
            let _query = _.cloneDeep(ctx.state.query);

            let query = qs.stringify(_query);
            return new Promise((resolve, reject) => {
                axios
                    .get('/parking-lots?' + query)
                    .then((response) => resolve(response))
                    .catch((error) => reject(error));
            });
        },
        fetchPark(ctx, id, query = {}) {
            query.populate = [
                'pictures',
                'location.parent.parent.parent',
                'managers',
                'managers.role',
                'managers.parkingLots',
                'sections.children',
                'sections.lots',
                'sections.children.lots',
            ];
            query.calculateDistance = true;
            query.latitude = _.get(query, 'latitude', 0);
            query.longitude = _.get(query, 'longitude', 0);

            return new Promise((resolve, reject) => {
                axios
                    .get(`/parking-lots/${id}`, { params: query })
                    .then((response) => resolve(response))
                    .catch((error) => reject(error));
            });
        },
        updatePark(ctx, data) {
            let query = qs.stringify({
                populate: ['pictures', 'location.parent.parent.parent', 'managers'],
            });
            return new Promise((resolve, reject) => {
                let _data = _.assign({}, data);
                let id = _data.id;
                delete _data.id;
                _data.pictures = _.get(_data, 'pictures[0].id') ? [_.get(_data, 'pictures[0].id')] : [];
                axios
                    .put(`/parking-lots/${id}?${query}`, { data: _data })
                    .then((response) => resolve(response))
                    .catch((error) => reject(error));
            });
        },
        addPark(ctx, parkData) {
            parkData = _.assign({}, parkData);
            delete parkData.sections;

            return new Promise((resolve, reject) => {
                axios
                    .post('/parking-lots', { data: parkData })
                    .then((response) => resolve(response))
                    .catch((error) => reject(error));
            });
        },
        deletePark(ctx, id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/parking-lots/${id}`)
                    .then((response) => resolve(response))
                    .catch((error) => reject(error));
            });
        },
        deleteManyParks(ctx, query = {}) {
            query = qs.stringify(query);
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/parking-lots/many?${query}`)
                    .then((response) => resolve(response))
                    .catch((error) => reject(error));
            });
        },

        /*         
export function deleteManyItems(query = {}) {
    query = qs.stringify(query);
    return axios.delete(`/items/many?${query}`);
} */
        /*   addSections(ctx, sectionsData) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/parking-lots-sections', { data: sectionsData })
                    .then((response) => resolve(response))
                    .catch((error) => reject(error));
            });
        }, */
    },
};
